//import MAAApp from './components/base.js';

// Libs
import userHandler from './lib/user.js';
import contentHandler from './lib/content.js';

// Parts
import analyticsHandler from './parts/analytics.js';
import eventListners from './parts/eventListners.js';
import scopeTest from './parts/scopeTest.js';

// Core Components
let QUEUE_COMPONENT_LIST = {};
import COMPONENT_MAASPINNER from './components/spinner.js';
QUEUE_COMPONENT_LIST.COMPONENT_MAASPINNER = COMPONENT_MAASPINNER;
import COMPONENT_MAANAV from './components/nav.js';
QUEUE_COMPONENT_LIST.COMPONENT_MAANAV = COMPONENT_MAANAV;
import COMPONENT_DSBWORKSPACE from './components/dsb-workspace.js';
QUEUE_COMPONENT_LIST.COMPONENT_DSBWORKSPACE = COMPONENT_DSBWORKSPACE;

// Application Components
import COMPONENT_DSBLIST from './components/dsb-list/dsb-list.js';
QUEUE_COMPONENT_LIST.COMPONENT_DSBLIST = COMPONENT_DSBLIST;
import COMPONENT_DSBSTEPBAR from './components/dsb-stepbar.js';
QUEUE_COMPONENT_LIST.COMPONENT_DSBSTEPBAR = COMPONENT_DSBSTEPBAR;
import COMPONENT_DSBCATCHUP from './components/dsb-catchup.js';
QUEUE_COMPONENT_LIST.COMPONENT_DSBCATCHUP = COMPONENT_DSBCATCHUP;
import COMPONENT_DSBREADER from './components/dsb-reader.js';
QUEUE_COMPONENT_LIST.COMPONENT_DSBREADER = COMPONENT_DSBREADER;
import COMPONENT_DSBPOST from './components/dsb-post.js';
QUEUE_COMPONENT_LIST.COMPONENT_DSBPOST = COMPONENT_DSBPOST;
import COMPONENT_DSBTASKS from './components/dsb-tasks.js';
QUEUE_COMPONENT_LIST.COMPONENT_DSBTASKS = COMPONENT_DSBTASKS;
import COMPONENT_DSBQUIZ from './components/dsb-quiz.js';
QUEUE_COMPONENT_LIST.COMPONENT_DSBQUIZ = COMPONENT_DSBQUIZ;



async function dynamic_import_component(name, file=false) {
  if(!file)
  {
    file = name;
  }
  let component = await import('./compile/'+file+'.js');
  component.default(); // Module loaded (export default)!
  customElements.define(name, component);
}

// contenthierachy_parts

export class DSBAPP extends HTMLElement {

  static get observedAttributes() {
    return ['layout','app_state'];
  }

  constructor() {
    super();
    console.log('constructor DSBAPP');
    var _this = this;
    this.DEBUG = true;
    this._errorMessage='';
    this._tabs = false;
    this._app_title = document.title;
    this._app_tab_title = '';
    this._load_complete=false;
    this._connected = false;
    this._cronIntervals = {};
    this._onboarding_component=false;
    /**
    window.addEventListener('load', function(){
        console.log("Initial init...");
        _this.init();
      });
    */
    if(this.title)
    {
      this.title = document.title;
    }
    this.logged_in = false;
    this._root_path='';
    this._html__closebutton='';

  }

  get logo() {
      return this.getAttribute('logo');
  }

  set logo(newValue){
      this.setAttribute('logo', newValue);
  }

  get app_path() {
      return this.getAttribute('app_path');
  }

  set app_path(newValue){
      this.setAttribute('app_path', newValue);
  }

  get app_state() {
      return this.getAttribute('app_state');
  }

  set app_state(newValue){
      this.setAttribute('app_state', newValue);
  }

  get app_name() {
      return this.getAttribute('app_name');
  }

  set app_name(newValue){
      this.setAttribute('app_name', newValue);
  }

  get router() {
      return this.getAttribute('router');
  }

  set router(newValue){
      this.setAttribute('router', newValue);
  }

  get layout() {
      return this.getAttribute('layout');
  }

  set layout(newValue){
      this.setAttribute('layout', newValue);
  }

  get title() {
      return this.getAttribute('title');
  }

  set title(newValue){
      this.setAttribute('title', newValue);
      //this.title = newValue;
  }

  get settings() {
      return this.getAttribute('settings');
  }

  set settings(newValue){
      this.setAttribute('settings', newValue);
  }

  get tabs() {
      if(!this._tabs)
      {
          this._tabs = JSON.parse(``+this.getAttribute('tabs')+``);

      }
      return this._tabs;
  }

  set tabs(newValue){
      this.setAttribute('tabs', newValue);
  }

  _createUUID() {
    return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function(c) {
      var r = Math.random() * 16 | 0, v = c == 'x' ? r : (r & 0x3 | 0x8);
      return v.toString(16);
    });
  }

  _update_DocumentTitle(newValue='')
  {
    let newtitle = ''
    if(this._app_title)
    {
      newtitle=this._app_title;
    }
    if(this._app_tab_title)
    {
      newtitle+=" - "+this._app_tab_title+"";
    }
    if(newValue && newValue.length >0)
    {
      newtitle+=" / "+newValue;
    }
    //console.error('########## SETTING TITLE:'+newtitle,this._app_title,this._app_tab_title);
    document.title = newtitle;
  }

  _dynamic_define_component(name)
  {
    let this_component = 'COMPONENT_'+name.toUpperCase().replace('-','');
    if(this_component in QUEUE_COMPONENT_LIST)
    {
      customElements.define(name, QUEUE_COMPONENT_LIST[this_component]);
      delete QUEUE_COMPONENT_LIST[this_component];
    }
  }


  async init()
  {
    try
    {

      // Register Components
      this._log('debug','init','Registering webcomponents...');
      this._dynamic_define_component('maa-spinner');
      this._dynamic_define_component('maa-nav');
      this._dynamic_define_component('maa-dsb');
      this._dynamic_define_component('dsb-workspace');

      //customElements.define('dsb-list', COMPONENT_DSBLIST);

      //customElements.define('dsb-catchup', COMPONENT_DSBCATCHUP);

      let settings = JSON.parse(``+this.settings+``);
      this.setting = settings;
      this._log('debug','init','Setting settings',this.setting);

      let loading_component = document.createElement("div");
      loading_component.style="text-align: center;position:absolute;top:25%; width:100%;padding:0px;margin:0px;";
      let loading_message = document.createElement("small");
      loading_message.style="font-weight:normal;font-size:10px;padding-top:10px;color:grey;";
      loading_message.innerHTML = "Setting up...";
      if(('loading_logo' in settings) && settings.loading_logo !== 'off')
      {
        loading_component.innerHTML = `
          <p style="background-image:url('`+this.app_path+`/images/FW-default.svg');background-position: 50% 0px;background-size: auto;background-repeat: no-repeat;width:100%;height:78px;padding:0px;margin:0px;"></p>
          <p style=" position:relative;height:84px;width:100%;padding:0px;margin:0px;">
            <maa-spinner></maa-spinner>
          </p>
          <h3 style="font-weight:normal;font-size:12px;padding-top:10px;margin:0px;">Loading....</h3>
        `;
      }
      else
      {
         loading_component.innerHTML = `
          <maa-spinner></maa-spinner>
        `;
      }
      this.innerHTML = '';
      loading_component.append(loading_message);
      this.append(loading_component);

       // Add parts
      this._setAnalytics = analyticsHandler;
      this._setApplicationListners = eventListners;

      this.dsbClient = {};

      // Setup Event listners
      this._log('debug','init','Setup event listners...');
      this._setApplicationListners();

      var _this = this;


      // Get additional customElements
      /**
      if(`customElements` in settings)
      {
        if(settings.customElements !== null && typeof Array.isArray(settings.customElements))
        {
          for(let i = 0; i < settings.customElements.length; i++)
          {
            // ok now what :)
          }
        }
      }
      */

      if(!('default_service' in settings))
      {
        settings.default_service='post';
      }

      if(!(`fw_tnc_url` in settings))
      {
        settings.fw_tnc_url = 'https://www.markallengroup.com/terms-and-conditions/';
      }

      if(`dsb_user_url` in settings)
      {
        this.dsbClient.user = new userHandler();

        if(!('refresh_token' in settings))
        {
          settings.refresh_token = '';
        }
        let user_settings = {};
        if('app_path' in settings)
        {
          user_settings.app_path=settings.app_path;
        }
        if('app_hash_url' in settings)
        {
          user_settings.app_hash_url=settings.app_hash_url;
        }
        for(let setting_key in settings)
        {
          if(setting_key.startsWith('user__'))
          {
            user_settings[setting_key.replace('user__','')]=settings[setting_key];
          }
        }
        loading_message.innerHTML='Setting up user...';
        await this.dsbClient.user.init(settings.dsb_user_url,settings.refresh_token,user_settings);
      }
      else
      {
        throw "Missing dsb_user_url setting";
      }

      // Set content
      if(`dsb_client_url` in settings)
      {
        let hooks = {};
        let headers = {};

        this.dsbClient.content = new contentHandler();
        loading_message.innerHTML='Connecting to content api...';
        await this.dsbClient.content.init(settings.dsb_client_url, hooks, this.dsbClient.user);

        if(`image_path` in settings)
        {
            this.dsbClient.content.image_path = settings.image_path;
        }

        if(this.app_path)
        {
            this.dsbClient.content.app_path = this.app_path;
        }

        this.dsbClient.content.default_service=settings.default_service;


        hooks.filters = {};
        hooks.filters.formatData_lookup = function(type, value)
        {
          if("lookups" in settings)
          {
            if(typeof settings.lookups === 'object' && settings.lookups !== null)
            {
              if(type in settings.lookups)
              {
                if( value in settings.lookups[type])
                {
                  return settings.lookups[type][value];
                }
              }
              else
              {
                console.log('formatData_lookup::Not sure what '+type+' is...');
              }
            }
            else
            {
              console.log('formatData_lookup:: Missing lookups...');
            }
          }
          return value;
        }

      }
      else
      {
        throw "Missing dsb_client_url setting";
      }

      // Setup and Instantiate Analytics
      this._setAnalytics();

      var hashchange = function() {
        let hash = location.hash;
        if(hash.length > 0)
        {
          if(hash.indexOf("#/") > -1)
          {
            hash = hash.substring((hash.indexOf("#/")+2),hash.length);
          }
          hash = hash.split("/");
          _this._route(hash[0], hash[1], hash[2], hash.slice(3,hash.length), '');
        }
      };

      window.addEventListener('dsb_app-reload', function(){
        console.debug("Reloading from path...");
        //Fire hashchange function for initial load
        hashchange();
      });

      window.addEventListener('hashchange', function(){
        console.debug("Hash change detected...");
        hashchange();
      }, false);

      this._log('debug','init',"Setting viewport...");
      this.dsbClient.user.env.refreshViewPort();

      if(!await this.dsbClient.user.is_loggedin())
      {
        this._log('warning','init','Not logged in...');
        this._errorMessage = 'Not Logged in....';
        loading_message.innerHTML='Not logged in...';
        if(!await this.dsbClient.user.is_offline())
        {
          if(this.dsbClient.user.isPending())
          {
            loading_message.innerHTML='Login pending...';
            this.setAttribute(`layout`, `login-pending`);
          }
          else
          {

              if(!this.dsbClient.user.run_login_redirect())
              {
                this.setAttribute(`layout`, `login`);
              }
              else
              {
                  //throw "Cannot login to app";
                  return;
              }
          }
        }
        else
        {
            this.setAttribute(`layout`, `offline`);
        }
        this._render();
      }
      else
      {
        this._log('debug','init','You appear to be logged in :)');
        loading_message.innerHTML='Checking preconditions...';
         // Ok check for preconditions
        if(('preconditions' in settings) && (settings.preconditions == 'on'))
        {
           this._log('debug','init','Has preconditions');

          // App must be installed
          if(('preconditions__install' in settings) && settings.preconditions__install == 'on')
          {
            if(!this.dsbClient.user.env.isInstalled())
            {
              this._log('debug','init','Requires installation');
              let thisOS = this.dsbClient.user.env.getOS();
              //alert('jasons quick test'+JSON.stringify(this.dsbClient.user.env.get()));
              if('preconditions__install-'+thisOS+'_postid' in settings)
              {
                await this._dynamic_define_component('dsb-post');
                let component = document.createElement("dsb-post");
                component.setDSBClient(this.dsbClient);
                component.setAttribute(`service`, 'static');
                component.setAttribute('post_id', settings['preconditions__install-'+thisOS+'_postid']);
                component.innerHTML = `<maa-spinner></maa-spinner>`;
                window.dispatchEvent(new CustomEvent('dsb-pwa-transient_modal', {detail: {content:component,hide:['close','refresh']}}));
                return;

              }
              else if('preconditions__install_postid' in settings)
              {
                  await this._dynamic_define_component('dsb-post');
                  let component = document.createElement("dsb-post");
                  component.setDSBClient(this.dsbClient);
                  component.setAttribute(`service`, 'static');
                  component.setAttribute(`settings`,JSON.stringify({'base_update':'off','header':'off','clean_body':'on','pulldown_refresh':'off','lazy_images':'off'}));
                  component.setAttribute('post_id', settings.preconditions__install_postid);
                  component.innerHTML = `<maa-spinner></maa-spinner>`;
                  window.dispatchEvent(new CustomEvent('dsb-pwa-transient_modal', {detail: {content:component,hide:['close','refresh']}}));
                  return;
              }
              else
              {
                  let component = document.createElement("div");
                  let component_uid = this._createUUID();
                  component.innerHTML = `
                  <div>
                  <center><svg style="max-width:300px;" xmlns="http://www.w3.org/2000/svg" enable-background="new 0 0 24 24" viewBox="0 0 24 24" width="40%" fill="#fcdc18"><g><rect fill="none" height="24" width="24"/></g><g><g><path d="M20,17H4V5h8V3H4C2.89,3,2,3.89,2,5v12c0,1.1,0.89,2,2,2h4v2h8v-2h4c1.1,0,2-0.9,2-2v-3h-2V17z"/><polygon points="17,14 22,9 20.59,7.59 18,10.17 18,3 16,3 16,10.17 13.41,7.59 12,9"/></g></g></svg>
                  <h2>This app requires installation</h2>
                  <p>In your browsers menu please click click "Add to home".<br/>
                  <small>Note: You may be asked to login and/or enter a pin code on install</small>
                  </p>
                  </center>
                  </div>
                  `;
                  window.dispatchEvent(new CustomEvent('dsb-pwa-transient_modal', {detail: {content:component,hide:['close','refresh']}}));
                  return;
              }
            }
          }

          // App requires pin
          if(('preconditions__pin' in settings) && settings.preconditions__pin !== 'off')
          {
            let chars_to_numbers = function(string){
              if(isNaN(string))
              {
                let matrix = { a: 1, b: 2, c: 3, d: 4, e: 5, f: 6, g: 7, h: 8, i: 9, j: 10, k: 11, l: 12, m: 13, n: 14, o: 15, p: 16, q: 17, r: 18, s: 19, t: 20, u: 21, v: 22, w: 23, x: 24, y: 25, z: 26 }
                let result = [];
                for(let i = 0; i<string.length;i++)
                {
                  result.push(matrix[string[i]]);
                }
                return result.join('');
              }
              return string;
            };


            let expected_accesstoken = chars_to_numbers((settings.preconditions__pin=='app_name_as_number' || settings.preconditions__pin=='on'?this.app_name:settings.preconditions__pin));
            let _fw_workbench_accesstoken = this.dsbClient.user.getUserCookie('fw_workbench_'+this.app_name+'_pin');

            // Check for legacy cookie
            let delete_lagacy_cookie = false;
            if(!_fw_workbench_accesstoken)
            {
              _fw_workbench_accesstoken = this.dsbClient.user._getCookie('fw_workbench_'+this.app_name+'_pin');
              delete_lagacy_cookie=true;
            }

            if(_fw_workbench_accesstoken && _fw_workbench_accesstoken == expected_accesstoken)
            {
              // ok cool
              // Migrate to new cookie
              if(delete_lagacy_cookie)
              {
                this.dsbClient.user.setUserCookie('fw_workbench_'+this.app_name+'_pin',_fw_workbench_accesstoken,3650);
                this.dsbClient.user._deleteCookie('fw_workbench_'+this.app_name+'_pin','/',window.location.hostname);
              }
            }
            else
            {
              let component = document.createElement("div");
              let component_uid = this._createUUID();
              component.innerHTML = `
              <div>
                <center>
                <svg style="max-width:300px;" xmlns="http://www.w3.org/2000/svg" enable-background="new 0 0 24 24" viewBox="0 0 24 24" width="40%" fill="#fcdc18"><g><path d="M0,0h24v24H0V0z" fill="none"/></g><g><g><path d="M20,4H4C2.9,4,2,4.9,2,6v12c0,1.1,0.9,2,2,2h16c1.1,0,2-0.9,2-2V6C22,4.9,21.1,4,20,4z M7.64,15H6.49v-4.5l-0.9,0.66 l-0.58-0.89L6.77,9h0.87V15z M13.5,15H9.61v-1.02c1.07-1.07,1.77-1.77,2.13-2.15c0.4-0.42,0.54-0.69,0.54-1.06 c0-0.4-0.31-0.72-0.81-0.72c-0.52,0-0.8,0.39-0.9,0.72l-1.01-0.42c0.01-0.02,0.18-0.76,1-1.15c0.69-0.33,1.48-0.2,1.95,0.03 c0.86,0.44,0.91,1.24,0.91,1.48c0,0.64-0.31,1.26-0.92,1.86c-0.25,0.25-0.72,0.71-1.4,1.39l0.03,0.05h2.37V15z M18.75,14.15 C18.67,14.28,18.19,15,16.99,15c-0.04,0-1.6,0.08-2.05-1.51l1.03-0.41c0.03,0.1,0.19,0.86,1.02,0.86c0.41,0,0.89-0.28,0.89-0.77 c0-0.55-0.48-0.79-1.04-0.79h-0.5v-1h0.46c0.33,0,0.88-0.14,0.88-0.72c0-0.39-0.31-0.65-0.75-0.65c-0.5,0-0.74,0.32-0.85,0.64 l-0.99-0.41C15.2,9.9,15.68,9,16.94,9c1.09,0,1.54,0.64,1.62,0.75c0.33,0.5,0.28,1.16,0.02,1.57c-0.15,0.22-0.32,0.38-0.52,0.48 v0.07c0.28,0.11,0.51,0.28,0.68,0.52C19.11,12.91,19.07,13.66,18.75,14.15z"/></g></g></svg>
                <h3>This app is currently in closed beta.</h3>
                <p style="align:center;font-size:15px;">To access please enter your closed beta access pin in the box below, doing so means you agree to the <a href="`+settings.fw_tnc_url+`" target="_blank">terms and conditions</a>.</p>
                </center>
                <p>
                `+(_fw_workbench_accesstoken.length>0?'<div style="border:solid 1px #d2222a;background-color:#fbebed;margin: auto;width: 50%;margin-bottom: 10px;padding-left: 10px;display: block;padding-top: 10px;padding-bottom: 10px;padding-right: 10px;">Sorry this token is either invalid or has expired</div>':'')+`
                <input id="`+component_uid+`__access_restriction_token" type="text" alt="Access code" value="" style="height: 44px;width: 50%;margin: auto;display: block;text-align: center;margin-bottom: 10px;">
                </div>
              `;
              let component_submit = document.createElement("span");
              component_submit.style = 'display:inline-block;background-color: #d92835;color:#fff;font-size: 14px; padding-left: 10px;  padding-right: 10px; cursor: pointer; height: 44px; line-height: 44px; width: 50%; margin: auto; display: block; text-align: center;';
              component_submit.innerHTML = 'Participate in beta';
              component_submit.onclick = function ()
              {
                  let token = document.getElementById(component_uid+'__access_restriction_token');
                  _this.dsbClient.user.setUserCookie('fw_workbench_'+_this.app_name+'_pin',token.value,3650);
                  window.location.reload();
              }
              component.append(component_submit);
              window.dispatchEvent(new CustomEvent('dsb-pwa-transient_modal', {detail: {content:component,hide:['close','refresh']}}));
              return;
            }

          }

          // Onboarding
          if('onboarding_postid|version' in settings)
          {
            let _fw_workbench_onboarding = this.dsbClient.user.getUserCookie('fw_workbench_'+this.app_name+'_onboarding');
            if(_fw_workbench_onboarding && _fw_workbench_onboarding==settings['onboarding_postid|version'])
            {
              //Skip onboarding
            }
            else
            {
              let post_id = settings['onboarding_postid|version'];
              post_id = post_id.split('|')[0];
              await this._dynamic_define_component('dsb-post');
              this._onboarding_component = document.createElement("dsb-post");
              this._onboarding_component.setDSBClient(this.dsbClient);
              this._onboarding_component.setAttribute(`service`, 'static');
              this._onboarding_component.setAttribute('post_id', post_id);
              this._onboarding_component.setAttribute(`settings`,JSON.stringify({'base_update':'off','header':'off','clean_body':'on','pulldown_refresh':'off','lazy_images':'off'}));
              this._onboarding_component.innerHTML = `<maa-spinner></maa-spinner>`;
              this.dsbClient.user.setUserCookie('fw_workbench_'+_this.app_name+'_onboarding',settings['onboarding_postid|version'],3650);// 10 Year cookie
            }

          }
        }

        if(location.hash.length > 0)
        {
          //Fire hashchange function for initial load
          loading_message.innerHTML='Resuming...';
          hashchange();
        }
        else
        {
          // Go find tab or app
          loading_message.innerHTML='Rendering...';
          this._render();
        }
      }
    }
    catch(ex)
    {
        this._log('error','init', 'Cannot init DSBAPP!', ex);
        this._errorMessage=ex;
        this.layout='error';
        this._render();
    }

  }

   _log(type,source,message,data='')
  {
    let _message = 'dsb-app/DSBAPP::'+source+'- '+message;
    switch(type)
    {
       case "debug":
         console.debug(_message,data);
        break;
      case "warning":
         console.warn(_message,data);
        break;
      case "error":
         console.error(_message,data);
        break;
      default:
          console.log(_message,data);
    }
  }

  attributeChangedCallback(name, oldValue, newValue)
  {
    if(`app_state` == name && oldValue != null && oldValue!==newValue )
    {
      this.connectedCallback();
    }
  }

  connectedCallback()
  {
    document.body.style.backgroundColor = "#4a4a4a";
    if(this.app_state =='wait')
    {
      let _this = this;
      // Ok waiting.....
      this._log('debug','connectedCallback','Waiting....',this.app_state);
      this.timeout__wait = setTimeout(function(){
          console.error('###### --- fw-workbench CRON/connectedCallback -----');
          if(_this.app_state == 'wait')
          {
            _this.innerHTML=`
            <div style="text-align: center;position:absolute;top:25%; width:100%;padding:0px;margin:0px">
            <p style="background-image:url('`+_this.app_path+`/images/FW-default.svg');background-position: 50% 0px;background-size: auto;background-repeat: no-repeat;width:100%;height:78px;padding:0px;margin:0px;"></p>
            <h3 style="font-weight:normal;font-size:12px;padding-top:10px;margin:0px;">Updated, please restart the app</h3>
            <small style="font-weight:normal;font-size:10px;padding-top:10px;color:grey;">Sorry, this update requires a restart.</small>
            </div>'`;
          }
        },60000);
    }
    else
    {
      this._log('debug','connectedCallback','Runnig init....',this.app_state);
      if(this.timeout__wait)
      {
        clearTimeout(this.timeout__wait);
      }

      //Setup cron


      this._connected = true;
      this.init();
    }
  }

  async _render(mode=null)
  {
    try
    {
      this._root_path = '/#/'+this.layout;

      let route = `document.querySelector('dsb-app').route(this);`;
      let tabbed_element = '';

      if(this.tabs && this.setting)
      {
          if(Object.keys(this.tabs).length > 1)
          {
            tabbed_element = document.createElement("nav");
            let tabbed_element_ul = document.createElement("ul");

            for(let aTab in this.tabs)
            {
                if('id' in this.tabs[aTab])
                {
                    let _li = document.createElement("li");
                    let li_class = 'show-name';
                    if('icon' in this.tabs[aTab])
                    {
                      li_class = this.tabs[aTab].icon;
                    }
                    _li.innerHTML = `<a href="javascript:return false;" onclick="window.location.hash='/`+this.layout+`/static/post/`+this.tabs[aTab].id+`'"class="`+li_class+` `+(window.location.hash == `#/`+this.layout+`/static/post/`+this.tabs[aTab].id?' active':'')+`"><span>`+this.tabs[aTab].name+`<span></a>`;
                    tabbed_element_ul.append(_li);
                }
                else
                {
                    console.error('Missing id in Tab', this.tabs[aTab]);
                    throw 'Issue with Tab';
                }
            }
            tabbed_element.append(tabbed_element_ul);
          }
      }

      // Check for tabs in setup if no layout has been specified
      if(!this.layout && !location.hash)
      {
          if(this.tabs && this.setting)
          {
              if(Object.keys(this.tabs).length > 1)
              {

                  this.layout = `tabbed`;
              }
              else
              {
                  this.layout = `single`;
              }

              for(let aTab in this.tabs)
              {
                  if('id' in this.tabs[aTab])
                  {
                      window.location.hash = '/'+this.layout+'/static/post/'+this.tabs[aTab].id;
                      return;
                  }
                  else
                  {
                      console.error('Missing id in Tab', this.tabs[aTab]);
                      throw 'Issue with Tab';
                  }
              }
          }
      }

      console.log('Setting layout '+this.layout+'...',this.setting)

      //<div class="icon-chevron-left" onclick="window.parent.postMessage('dsb_app-iframeclose');"><span style="padding-right:10px;cursor:pointer;">Back</span></div>

      this._html_offlineindicator = `<div class="m-icon-offline fw_workspace__offline_indicator" style="display:none;margin-left: 0px;font-size: 25px;"><span style="padding-right:10px;">&nbsp;<span></span></span></div>`;

      this._html_refresh = `<div class="icon-refresh icon-clickable" id="fw_workspace__update_indicator" onclick="window.location.reload(true);this.className='icon-refresh icon-rotate icon-clickable'" style="font-size:25px;"><span style="padding-right:10px;">&nbsp;</span></div>`;

      this._html__closebutton = `<div class="icon-chevron-left" onclick="window.parent.postMessage('dsb_app-iframeclose');"><span style="padding-right:10px;cursor:pointer;">Back<span></div>`;
      if((typeof this.setting === 'object') && (this.setting !== null) && ('close_button' in this.setting))
      {
        switch(this.setting['close_button'])
        {
          case "iframe_back":
              this._html__closebutton = `<div class="icon-chevron-left" onclick="window.parent.postMessage('dsb_app-iframeclose');"><span style="padding-right:10px;cursor:pointer;">Back<span></div>`;
              break;
          case "iframe_close":
              this._html__closebutton = `<div class="m-icon-close icon-clickable" onclick="window.parent.postMessage('dsb_app-iframeclose');" style="margin-left: 0px;font-size: 25px;"><span style="padding-right:10px;">&nbsp;<span></span></span></div>`;
              break;
          default:
              this._html__closebutton="";
              break;
        }

      }

      this._load_complete=true;
      switch(this.layout)
      {
        case "reader":
          this.innerHTML = `
            <dsb-modal>
              <header>
                <ul>
                  <li class="title"></li>
                  <li class="logo"><a href="" onclick="return false;"><img src="`+this.logo+`" alt="Farmers Weekly"/></a></li>
                  <li class="tray"><div class="icon-close" onclick="document.querySelector('dsb-modal').classList.toggle('show');"><span>Close<span></div></li>
                </ul>
              </header>
              <dsb-modal-workspace></dsb-modal-workspace>
            </dsb-modal>
            <header>
              <ul>
                <li class="logo"><a href="" onclick="return false;"><img src="`+this.logo+`" alt="Farmers Weekly"/></a></li>
                <li class="title"><div><span id="dsb-pwa_appname"></span><span id="dsb-pwa_title"></span></div></li>
                <li class="tray" id="dsb-pwa_tray">
                  `+this._html_refresh+this._html_offlineindicator+this._html__closebutton+`
                </li>
              </ul>
            </header>
            <dsb-workspace>
              <maa-spinner></maa-spinner>
            </dsb-workspace>
          `;
          break;
        case "single":
          this.innerHTML = `
          <dsb-modal>
              <header>
                <ul>
                  <li class="title"></li>
                  <li class="logo"><a href="" onclick="return false;"><img src="`+this.logo+`" alt="Farmers Weekly"/></a></li>
                  <li class="tray"><div class="icon-close" onclick="document.querySelector('dsb-modal').classList.toggle('show');"><span>Close<span></div></li>
                </ul>
              </header>
              <dsb-modal-workspace></dsb-modal-workspace>
            </dsb-modal>
            <header>
              <ul>
                <li class="logo"><a href="" onclick="return false;"><img src="`+this.logo+`" alt="Farmers Weekly"/></a></li>
                <li class="title"><div><span id="dsb-pwa_appname"></span><span id="dsb-pwa_title"></span></div></li>
                <li class="tray" id="dsb-pwa_tray">
                  `+this._html_refresh+this._html_offlineindicator+this._html__closebutton+`
                </li>
              </ul>
            </header>
            <dsb-workspace>
              <maa-spinner></maa-spinner>
            </dsb-workspace>
          `;
          break;
        case "comrisk":
          this.innerHTML = `
            <header>
              <ul>
                <li class="logo"><a href="" onclick="return false;"><img src="`+this.logo+`" alt="Farmers Weekly"/></a></li>
                <li class="title"><div><span id="dsb-pwa_appname"></span><span id="dsb-pwa_title"></span></div></li>
                <li class="tray" id="dsb-pwa_tray">
                  `+this._html_refresh+this._html_offlineindicator+this._html__closebutton+`
                </li>
              </ul>
            </header>
            <dsb-workspace>
              <iframe style="width: 100%;
  height: 100%;margin: 0;
  border: 0;
  scroll-behavior: auto;" src="https://app.comrisk.nl/dairy_hedging"></iframe>
            </dsb-workspace>
          `;
          break;
        case "tabbed":
          this.innerHTML = `

            <dsb-modal>
              <header>
                <ul>
                  <li class="title"></li>
                  <li class="logo"><a href="`+this._root_path+`" onclick="return false;"><img src="`+this.logo+`" alt="Farmers Weekly"/></a></li>
                  <li class="tray"><div class="icon-close" onclick="document.querySelector('dsb-modal').classList.toggle('show');"><span>Close<span></div></li>
                </ul>
              </header>
              <dsb-modal-workspace></dsb-modal-workspace>
            </dsb-modal>
            <header>
              <ul>
                <li class="logo"><a href="" onclick="return false;"><img src="`+this.logo+`" alt="Farmers Weekly"/></a></li>
                <li class="title"><div><span id="dsb-pwa_appname"></span><span id="dsb-pwa_title"></span></div></li>
                <li class="tray" id="dsb-pwa_tray">
                  `+this._html_refresh+this._html_offlineindicator+this._html__closebutton+`
                </li>
              </ul>
            </header>
            <dsb-workspace>
              <maa-spinner></maa-spinner>
            </dsb-workspace>
          `;
          this.append(tabbed_element);
          break;
        case "maintenance":
           this.innerHTML = `
            <dsb-modal>
              <header>
                <ul>
                  <li class="title"></li>
                  <li class="logo"><a href="`+this.root_path+`" onclick="return false;"><img src="`+this.logo+`" alt="Farmers Weekly"/></a></li>
                  <li class="tray"><div class="icon-close" onclick="document.querySelector('dsb-modal').classList.toggle('show');"><span>Close<span></div></li>
                </ul>
              </header>
              <dsb-modal-workspace></dsb-modal-workspace>
            </dsb-modal>
            <header>
              <ul>
                <li class="logo"><a href="" onclick="return false;"><img src="`+this.logo+`" alt="Farmers Weekly"/></a></li>
                <li class="title"><div><span id="dsb-pwa_appname"></span><span id="dsb-pwa_title"></span></div></li>
                <li class="tray" id="dsb-pwa_tray">
                  `+this._html_refresh+this._html_offlineindicator+this._html__closebutton+`
                </li>
              </ul>
            </header>
            <dsb-workspace>
              <div style="overflow-x: auto;min-height:200px;margin-top:30px;">
                  <article class="error-503" role="article">
                    <p>Maintenance work ongoing...</p>
                    <p>Sorry we are currently performing maintenance please <a href="javascript:return;" onclick="window.location.reload(true);">click here</a> to try again.</p>
                  </article>
              </div>
            </dsb-workspace>
            `;
            return false;
          break;
        case "login":
          this.innerHTML = `
            <dsb-modal>
              <header>
                <ul>
                  <li class="title"></li>
                  <li class="logo"><a href="`+this.root_path+`" onclick="return false;"><img src="`+this.logo+`" alt="Farmers Weekly"/></a></li>
                  <li class="tray"><div class="icon-close" onclick="document.querySelector('dsb-modal').classList.toggle('show');"><span>Close<span></div></li>
                </ul>
              </header>
              <dsb-modal-workspace></dsb-modal-workspace>
            </dsb-modal>
            <header>
              <ul>
                <li class="logo"><a href="" onclick="return false;"><img src="`+this.logo+`" alt="Farmers Weekly"/></a></li>
                <li class="title"><div><span id="dsb-pwa_appname"></span><span id="dsb-pwa_title"></span></div></li>
                <li class="tray" id="dsb-pwa_tray">
                  `+this._html_refresh+this._html_offlineindicator+this._html__closebutton+`
                </li>
              </ul>
            </header>
            <dsb-workspace>
              <div style="overflow-x: auto;min-height:200px;margin-top:30px;">
                  <article class="error-500" role="article">
                    <p>Sorry, you appear to be logged out...</p>
                    <p>Please <a href="`+this.dsbClient.user.get_login_url()+`">click here to login</a>.<br/>
                    Once you have <a href="javascript:return;" onclick="window.location.reload(true);">please click here</a> to try again.</p>
                  </article>
              </div>
            </dsb-workspace>
            `;
            return false;
            break;
        case "login-pending":
          this.innerHTML = `
            <maa-spinner>Session expired, reloading...</maa-spinner>
            `;
            return false;
            break;
        case "error":
          return this._throwFatalError();
            break;
        case "offline":
            this.innerHTML = `
            <header>
              <ul>
                <li class="logo"><a href="" onclick="return false;"><img src="`+this.logo+`" alt="Farmers Weekly"/></a></li>
                <li class="title"><div><span id="dsb-pwa_appname"></span><span id="dsb-pwa_title"></span></div></li>
                <li class="tray" id="dsb-pwa_tray">
                  `+this._html_refresh+this._html_offlineindicator+this._html__closebutton+`
                </li>
              </ul>
            </header>
            <dsb-workspace>
              <div style="overflow-x: auto;min-height:200px;margin-top:30px;">
                  <article class="error-90" role="article">
                    <p>Offline</p>
                    <p>Sorry, offline version not available.<br/>Please try again later when you have an internet connection :)</p>
                    <details>
                      <summary>Details</summary>
                      <div>
                        `+this._errorMessage+`
                      </div>
                    </details>
                  </article>
              </div>
            </dsb-workspace>
            `;
            this._errorMessage='';
            break;
        default:

          /**
          this.innerHTML = `
                  <div style="background-image:url('`+this.app_path+`/images/FW-default.svg');background-position: 50%;background-size: auto;background-repeat: no-repeat;width:100%;height:100px;position: absolute;top: 25%;"></div>
                  <maa-spinner></maa-spinner>
          `;
          */
          //this._load_complete=false;
          return this._throwFatalError('layout=Default');
      }

      //window.dispatchEvent(new CustomEvent('dsb_app-reload', {message: ''}));
      return true;
    }
    catch(ex)
    {
      return this._throwFatalError('_render:'+ex);
    }

  }

  _throwFatalError(message=null)
  {
    if(!(typeof message === 'string'))
    {
      message=this._errorMessage;
    }

    this.innerHTML = `
        <header>
        <ul>
          <li class="logo"><a href="`+this._root_path+`"><img src="`+this.logo+`" alt="Farmers Weekly"/></a></li>
          <li class="title"><div><span id="dsb-pwa_appname"></span><span id="dsb-pwa_title"></span></div></li>
          <li class="tray" id="dsb-pwa_tray">
          `+this._html__closebutton+`
          </li>
        </ul>
      </header>
      <dsb-workspace>
        <div class="dsb-workspace-overlay"></div>
        <div style="overflow-x: auto;min-height:200px;margin-top:30px;">
            <article class="error-500" role="article">
              <p>Sorry an error has occured.</p>
              <p>
                Please try again by <a href="javascript:return;" onclick="window.location.reload(true);">clicking here</a> or try again later.
              </p>
              <p>
                <details>
                  <summary>Details</summary>
                  <div>
                    `+message+`
                  </div>
                </details>
              </p>
            </article>
        </div>
      </dsb-workspace>
      `;
      console.error('dsb-app: Fatal Error',message,this._errorMessage);
      this._errorMessage='';
      return false;
  }

  async login()
  {
    let url = "https://www.fwi.co.uk/wp-login.php?action=refresh&type=pm-sso-token-redirect";
    let response = await fetch(url);
    console.log(response);
  }

  route(element)
  {
    if(element instanceof HTMLElement)
    {
      let service = element.getAttribute('data-service');
      let query = element.getAttribute('data-query');
      let id = element.getAttribute('data-id');
      let target = element.getAttribute('data-target');
      let type = element.getAttribute('data-type');
      if(id)
      {
        query = id;
      }
      this._route(this.layout, service, type, query, target);
    }
    else
    {
      console.log('router.routeByElement: Not an element');
    }
  }

  add_applist(tray_id)
  {
      let _this = this;
      // Set Feedback form
      if(`feedback_form_url` in _this.setting)
      {
        var apps_aside = document.createElement("aside");
        apps_aside.id="apps_aside_"+tray_id;
        apps_aside.setAttribute('class','right');
        apps_aside.setAttribute('data-append_location','');
        //feedback_aside.setAttribute('style','padding:10px;');

        window.dispatchEvent(new CustomEvent('dsb-pwa-append_tray', {detail: {onclick: async function(){

          let zindex = window.getZIndex(document.querySelector('#'+tray_id));
          let panel = document.querySelector('#apps_aside_'+tray_id);
          let append_location = panel.getAttribute('data-append_location');

          if(zindex && !isNaN(zindex))
          {
            panel.style.zIndex = zindex+1;
          }
          panel.innerHTML = `
            <maa-spinner></maa-spinner>
          `;
          panel.classList.toggle('show');
          if(!(panel.classList.contains('show')))
          {
            panel.innerHTML = ``;
          }

          try
          {

          }
          catch(ex)
          {
            console.error(ex);
            panel.innerHTML = `
              <div style="overflow-x: auto;min-height:200px;margin-top:30px;">
                  <article class="error-500" role="article">
                    <p style="font-size: 2em;">Sorry an error has occured.</p>
                    <p>Please try again later.</p>
                  </article>
              </div>`;
          }


        },icon: 'm-icon-apps',
          name: 'apps',
          icon_size: '25px',
          init_append:apps_aside,
          overlay:true,
          tray_id: tray_id
        }}));

      }
  }

  add_feedback(tray_id)
  {
      let _this = this;
      // Set Feedback form
      if(`feedback_form_url` in _this.setting)
      {
        var feedback_aside = document.createElement("aside");
        feedback_aside.id="feedback_aside_"+tray_id;
        feedback_aside.setAttribute('class','right');
        feedback_aside.setAttribute('data-append_location','');
        //feedback_aside.setAttribute('style','padding:10px;');

        window.dispatchEvent(new CustomEvent('dsb-pwa-append_tray', {detail: {onclick: async function(){

          let zindex = window.getZIndex(document.querySelector('#'+tray_id));
          let panel = document.querySelector('#feedback_aside_'+tray_id);
          let append_location = panel.getAttribute('data-append_location');

          if(zindex && !isNaN(zindex))
          {
            panel.style.zIndex = zindex+1;
          }
          panel.innerHTML = `
            <maa-spinner></maa-spinner>
          `;
          panel.classList.toggle('show');
          if(!(panel.classList.contains('show')))
          {
            panel.innerHTML = ``;
          }

          try
          {
            if('email' in _this.dsbClient.user.profile)
            {
              var feedback_aside_wrapper = document.createElement("div");
              feedback_aside_wrapper.setAttribute("style","border:0px;margin:0px;padding-left:10px;padding-right:10px;height:calc(100vh - 3em);");
              var feedback_aside_iframe = document.createElement("iframe");
              feedback_aside_iframe.id = 'feedback_aside_'+tray_id+'_iframe';
              feedback_aside_iframe.src = _this.setting.feedback_form_url+"&email="+_this.dsbClient.user.profile.email+"&sourceurl="+location+append_location;
              feedback_aside_iframe.setAttribute("data-target_url",_this.setting.feedback_form_url+"&email="+_this.dsbClient.user.profile.email+"&sourceurl="+location+append_location);
              feedback_aside_iframe.setAttribute("width","100%");
              feedback_aside_iframe.setAttribute("height","100%");
              feedback_aside_iframe.setAttribute("style","border:0px;margin:0px;padding:0px;");
              panel.innerHTML = ``;
              feedback_aside_wrapper.append(feedback_aside_iframe);
              panel.append(feedback_aside_wrapper);
            }
          }
          catch(ex)
          {
            console.error(ex);
            panel.innerHTML = `
              <div style="overflow-x: auto;min-height:200px;margin-top:30px;">
                  <article class="error-500" role="article">
                    <p style="font-size: 2em;">Sorry an error has occured.</p>
                    <p>Please try again later.</p>
                  </article>
              </div>`;
          }


        },icon: 'm-icon-feedback',
          online_only:true,
          name: 'feedback',
          icon_size: '25px',
          init_append:feedback_aside,
          overlay:true,
          tray_id: tray_id
        }}));

      }
  }

  async _route(app, service, type, query, target)
  {
      let _this = this;
      let rendered = false;

      try
      {
        if(app)
        {
          console.log('Ok routing for app ('+app+')..');
          this.setAttribute(`layout`, app);
          rendered = await this._render();
        }
        else
        {
          throw 'Dunno what to do';
        }

        if(rendered)
        {

          if(!service)
          {

            console.error('Routing error...',service,rendered);
            return;
          }

          if('dsb-modal-workspace' == target)
          {
            target = document.body.querySelector(target);
            target.innerHTML = `<maa-spinner></maa-spinner>`;
            document.querySelector('dsb-modal').classList.toggle('show');
          }
          else if(target)
          {
              target = document.body.querySelector(target);
          }
          else
          {
              target = document.body.querySelector('dsb-workspace');
          }

          var overlay = document.createElement("div");
          overlay.setAttribute(`class`,"dsb-workspace-overlay");
          overlay.innerHTML = '';

          switch(type)
          {
            case "collection":
                this._dynamic_define_component('dsb-reader');
                this._dynamic_define_component('dsb-tasks');
                this._dynamic_define_component('dsb-quiz');
                this._dynamic_define_component('dsb-post');
                var component = document.createElement("dsb-reader");
                component.setDSBClient(this.dsbClient);
                component.setAttribute(`service`, service);
                component.collection_id = query;
                component.innerHTML = `<maa-spinner></maa-spinner>`;
                target.innerHTML = ``;
                target.append(overlay);
                target.append(component);
                break;
            case "board":
                var component = document.createElement("dsb-board");
                component.setDSBClient(this.dsbClient);
                component.setAttribute(`service`, service);
                component.collection_id = query;
                component.innerHTML = `<maa-spinner></maa-spinner>`;
                target.innerHTML = ``;
                target.append(overlay);
                target.append(component);
                break;
            case "post":
                this._dynamic_define_component('dsb-post');
                this._dynamic_define_component('dsb-list');
                this._dynamic_define_component('dsb-stepbar');
                this._dynamic_define_component('dsb-reader');
                this._dynamic_define_component('dsb-tasks');
                this._dynamic_define_component('dsb-quiz');
                var component = document.createElement("dsb-post");
                component.setDSBClient(this.dsbClient);
                component.setAttribute(`service`, service);
                component.setAttribute('post_id', query);
                component.innerHTML = `<maa-spinner></maa-spinner>`;
                target.innerHTML = ``;
                target.append(overlay);
                target.append(component);
                break;
            default:
                this._dynamic_define_component('dsb-post');
                this._dynamic_define_component('dsb-list');
                var component = document.createElement("dsb-list");
                component.setDSBClient(this.dsbClient);
                component.setAttribute(`service`, service);
                component.setAttribute(`query`, query);
                component.setAttribute(`type`, type);
                component.setAttribute(`root_path`, this.layout);
                component.innerHTML = `<maa-spinner></maa-spinner>`;

                target.innerHTML = ``;
                target.append(component);
                break;
          }

          if((typeof this.setting === 'object') && (this.setting !== null))
          {
            if('tray_feedback' in this.setting)
            {
              switch(this.setting['tray_feedback'].toLowerCase())
              {
                case "off":
                    break;
                default:
                    this.add_feedback('dsb-pwa_tray');
                    break;
              }
            }
            else
            {
              this.add_feedback('dsb-pwa_tray');
            }

            if('tray_applist' in this.setting)
            {
              switch(this.setting['tray_applist'].toLowerCase())
              {
                case "off":
                    break;
                default:
                    this.add_applist('dsb-pwa_tray');
                    break;
              }
            }
            else
            {
              this.add_applist('dsb-pwa_tray');
            }

          }
          else
          {
            this.add_feedback('dsb-pwa_tray');
          }

          if(this._onboarding_component && this._onboarding_component instanceof HTMLElement)
          {
            window.dispatchEvent(new CustomEvent('dsb-pwa-transient_modal', {detail: {content: this._onboarding_component,hide:['refresh','feedback']}}));
          }

          console.log('In router:: Fetch '+service+'('+query+'), '+target);
        }
      }
      catch(ex)
      {
        return this._throwFatalError('_route:'+ex);
      }
  }
}


customElements.define('dsb-app', DSBAPP);
